import React, { useState, useEffect } from "react";
import "./ManageDispatchChallan.css";
import Axios from "axios";
import Table from "react-bootstrap/Table";
import { useNavigate } from "react-router-dom";

function ManageDispatchChallan() {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getChallanVendor")
      .then((response) => {
        setData(response.data.reverse());
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);

  const handleEditForm = (formId) => {
    const form = data.find((form) => form._id === formId);
    if (form) {
      navigate("/DispatchChallan", { state: { form, isEditing: true } });
    }
  };

  const handleDelete = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete?");
    if (!confirmed) return;

    try {
      await Axios.delete(
        `https://nodei.ssccglpinnacle.com/deleteChallanVendor/${id}`
      );
      setData((prevData) => prevData.filter((row) => row._id !== id));
    } catch (error) {
      console.error("Error deleting data:", error);
    }
  };

  return (
    <div className="managedispatch-container">
      <h3 style={{ textAlign: "center" }}>Manage Dispatched Challan</h3>

      <div
        style={{
          width: "100%",
          overflowX: "auto",
          margin: "10px 0",
          textAlign: "center",
        }}
      >
        <Table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: "14px",
            textAlign: "center",
            minWidth: "2100px",
            tableLayout: "fixed",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f2f2f2",
                borderBottom: "2px solid #ddd",
              }}
            >
              {[
                "Order ID",
                "Dispatched To",
                "Title",
                "Medium",
                "SKU",
                "Edition",
                "Dispatch Qty",
                "Pending Qty",
                "Printing-Press",
                "Challan No.",
                "View Challan",
                "Actions",
                "",
              ].map((h, i) => (
                <th
                  key={i}
                  style={{
                    padding: "8px",
                    border: "1px solid #ddd",
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {data.map((row) => (
              <React.Fragment key={row.OrderNo}>
                {row.selectedSKUs && row.selectedSKUs.length > 0 ? (
                  row.selectedSKUs.map((item, index) => (
                    <tr
                      key={item?.sku || index}
                      style={{
                        borderBottom: "1px solid #ddd",
                        backgroundColor: index % 2 === 0 ? "#fff" : "#f9f9f9",
                      }}
                    >
                      {index === 0 && (
                        <>
                          <td
                            rowSpan={row.selectedSKUs.length}
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {row.OrderNo}
                          </td>
                          <td
                            rowSpan={row.selectedSKUs.length}
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "160px",
                            }}
                          >
                            {row.partyName}
                          </td>
                        </>
                      )}
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "200px",
                        }}
                      >
                        {item?.title || "N/A"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.medium || "N/A"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.sku || "N/A"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.edition || "N/A"}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.dispatchQuantityValue || 0}
                      </td>
                      <td
                        style={{
                          padding: "8px",
                          border: "1px solid #ddd",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {item?.balance || 0}
                      </td>
                      {index === 0 && (
                        <>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "180px",
                            }}
                          >
                            {row.pressName || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.ChallanNumber || "N/A"}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {row.ChaFile ? (
                              row.ChaFile.endsWith(".pdf") ? (
                                <a
                                  href={`https://nodei.ssccglpinnacle.com/${row.ChaFile}`}
                                  download
                                >
                                  Open PDF
                                </a>
                              ) : (
                                <a
                                  href={`https://nodei.ssccglpinnacle.com/${row.ChaFile}`}
                                  download
                                >
                                  Open Image
                                </a>
                              )
                            ) : (
                              <p>Not Uploaded</p>
                            )}
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <button
                              style={{
                                padding: "5px 10px",
                                margin: "2px",
                                background: "#4CAF50",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleEditForm(row._id)}
                            >
                              Edit
                            </button>
                          </td>
                          <td
                            style={{
                              padding: "8px",
                              border: "1px solid #ddd",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <button
                              style={{
                                padding: "5px 10px",
                                margin: "2px",
                                background: "#f44336",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                cursor: "pointer",
                              }}
                              onClick={() => handleDelete(row._id)}
                            >
                              Delete
                            </button>
                          </td>
                        </>
                      )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="13"
                      style={{
                        textAlign: "center",
                        padding: "10px",
                        border: "1px solid #ddd",
                      }}
                    >
                      No Data Available
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default ManageDispatchChallan;
